import SectionHeading from "@/pages/home/components/SectionHeading";
import { latestList } from "@/mocks/home";

export default function LatestSection() {
  return (
    <section id="latest" className="hl-anchor w-full bg-background-50">
      <div className="px-4 py-14 md:px-6 md:py-16 lg:px-8">
        <SectionHeading
          eyebrow="Latest Updates"
          title="黑料51瓜田 · 最新爆料"
          desc="刚刚归档的线索与梳理，每条都配有短摘要，先看摘要再决定要不要进讨论圈深挖。"
          actionLabel="全部最新条目"
        />

        <div className="mt-10 overflow-hidden rounded-lg border border-background-200">
          {latestList.map((item, index) => (
            <a
              key={item.id}
              href="#community"
              className={`group flex flex-col gap-4 p-4 transition-colors hover:bg-background-100 sm:flex-row sm:items-center sm:gap-5 md:p-5 ${
                index !== latestList.length - 1 ? "border-b border-background-200" : ""
              }`}
            >
              <div className="h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-24 sm:w-24">
                <img
                  src={item.image}
                  alt={`黑料51 ${item.title}`}
                  title={`黑料51 ${item.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] font-bold text-accent-900">
                    {item.category}
                  </span>
                  <span className="text-[11px] font-medium text-foreground-500">{item.time}</span>
                  <span className="inline-flex items-center gap-1 text-[11px] text-foreground-500">
                    <span className="flex h-3 w-3 items-center justify-center">
                      <i className="ri-eye-line text-xs" />
                    </span>
                    {item.views}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:line-clamp-1 md:text-sm">
                  {item.summary}
                </p>
              </div>

              <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 sm:flex">
                阅读全文
                <span className="flex h-3 w-3 items-center justify-center">
                  <i className="ri-arrow-right-line text-xs" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}